<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("contract.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("contract.desc") }}</p>
        </CRow>
        <CButton
          @click="navigateToAddContract(null)"
          size="sm"
          color="success"
          class="ml-auto btn-lit-blue mob-w100"
        >{{ $t("contract.addContract") }}</CButton>
      </CCardHeader>

      <CCardBody v-if="allContractLs" class="user-manage-table pt-0px">
        <div class="m-auto max-width-1000px">
          <div class="card assign pricing-card sticky-title-bar">
            <div class="d-flex">
              <label for class="title">
                <strong>{{ $t("contract.contractCode") }}</strong>
              </label>
              <multiselect
                class="multiselect-assignprice"
                :searchable="true"
                :close-on-select="true"
                :track-by="'contractid'"
                :label="'contractcode'"
                v-model="selectedContract"
                :allow-empty="false"
                :show-labels="false"
                @input="onChange"
                :options="allContractLs.contractList"
                :placeholder="$t('contract.selectContract')"
              >
                <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['contractcode'] }}</span>
                    <!-- <strong class="right ml-auto">
                                        {{
                                        props.option['contractcode']
                                        }}
                    </strong>-->
                  </div>
                </template>
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
              </multiselect>
            </div>
          </div>

           <div class="page-controllers d-flex flex-flow-row justify-content-between card assign pricing-card stickyTitleBar">

                        <div class="page-controller-wrap d-flex ">
                            <div class="d-flex align-item-center per-item">
                                <span class="align-item-center d-flex w-185px">{{$t('manageAgent.itemsPerPage')}}</span>
                                <select class="form-control max-w-100px" v-model="pageWatchList.itemsPerPage" >
                                    <option v-for="itemsPerPage in pageWatchList.lsItemsPerPage" :key="itemsPerPage"
                                            :value="itemsPerPage">{{itemsPerPage}}
                                    </option>

                                </select>
                            </div>

                        </div>
             <div class="d-flex align-item-center page-n">
               <div class="mr-15px">
                 <cPaginationLenOption :paginationWatchLs="pageWatchList"/>
               </div>
               <CPagination
                       :activePage.sync="pageWatchList.currentPageNum"
                       :pages="getTotalPages()"
                       align="center"
               />
             </div>


                    </div>


          <div v-for="(contLs,contIndex) in selectedContractLs" :key="'contract'+contIndex">
            <CCard
              @click="navigateToAddContract(contLs)"
              v-if="contLs.contractcode!='All' && getListCountForView(contIndex!=0?contIndex-1:contIndex)"
              class="card assign pricing-card b-r-color"
            >

              <div class="card-head d-flex ai-center">
                <div class="d-flex align-items-center justify-content-between w-100" v-if="contLs.contractcode">
                  <div class="mr-10px">
                    <h3 v-if="contLs.contractcode" class="text-transform-uppercase">{{contLs.contractcode}}</h3>
                    <span v-if="contLs.description">{{contLs.description}}</span>
                  </div>
                  <CBadge
                    class="c-white"
                    :color="contLs.isactive? 'success' : 'danger'"
                  >{{contLs.isactive? $t("contract.active"): $t("contract.inactive")}}</CBadge>
                </div>
                <div class="align-right d-flex">
                  <!-- <div
                    col="1.5"
                    size="sm"
                    color="info removewrap"
                     v-c-tooltip.hover="{ content: $t('contract.viewTooltip') , active:false }"
                    class="action-c-btn icon-25px c-pointer"
                  >
                    <CIcon  name="cil-info" size="lg"></CIcon>
                  </div> -->
                  <!-- <div
                    @click.stop="toDeleteContract(contLs.contractid)"
                    col="2.5"
                    v-if="allContractLs.permission.canDelete"
                    size="sm"
                    color="danger"
                    v-c-tooltip.hover="{ content: $t('contract.deleteTooltip') , active:false }"
                    class="action-c-btn icon-25px c-pointer"
                  >
                    <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                  </div> -->
                  <!-- <div
                    @click.stop="navigateToAddContract(contLs)"
                    col="2.5"
                    v-if="allContractLs.permission.canEdit"
                    class="edit-icon icon-25px c-pointer"
                    color="info removewrap"
                    v-c-tooltip.hover="{ content: $t('contract.editTooltip') , active:false }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="512pt"
                      viewBox="0 0 512 512"
                      width="512pt"
                      style="fill:#3c4b64;"
                    >
                      <path
                        d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                      />
                      <path
                        d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                      />
                      <path
                        d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                      />
                    </svg>
                  </div> -->
                </div>
              </div>
              <div class="card-head d-flex ai-center justify-content-between d-flex pt-0px bb-none">
                <div class="align-left a-name">
                  <table class="contract">
                    <tbody>
                      <tr v-if="contLs.airline_code">
                        <td>{{$t("contract.airlineCode")}}</td>
                        <td>: {{contLs.airline_code}}</td>
                      </tr>
                      <tr v-if="contLs.traveldate_from && contLs.traveldate_to">
                        <td>{{$t("contract.travelDate")}}</td>
                        <td>: {{contLs.traveldate_from|formatDate}} {{' '+$t('contract.to')+' '}} {{contLs.traveldate_to|formatDate}}</td>
                      </tr>
                      <tr v-if="contLs.ticketingdate_from && contLs.ticketingdate_to">
                        <td>{{$t("contract.ticketingDate")}}</td>
                        <td>: {{contLs.ticketingdate_from|formatDate}} {{' '+$t('contract.to')+' '}} {{contLs.ticketingdate_to|formatDate}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="button-wrap-r mt-auto">
                  <div class="row">
                   <!-- <CCol>
                     <div
                    col="2.5"
                    size="sm"
                    color="info removewrap"
                    @click.stop="navigateToFareView(contLs)"
                     v-c-tooltip.hover="{ content: $t('contract.viewTooltip') , active:false }"
                    class=" icon-25px c-pointer"
                      >
                  
                      <div class="filled-icon-btn r-payment">
                              <img src="@imgPath/img/svg/icons/view.svg" alt="">
                      </div>
                     </div>
                  </CCol> -->
                    <CCol>
                      <div
                              @click.stop="navToScheduleAll(contLs)"

                              v-c-tooltip.hover="{ content: $t('contract.flightScheduleToolTip') , active:false }"
                      >
                        <img src="@/assets/az/img/svg/icons/flightschedule.svg" alt width="25px" class="c-pointer"/>
<!--                                              <span>{{$t('addContract.addFlightSchedule')}}</span>-->
                      </div>
                    </CCol>
                    <CCol>
                      <div
                              @click.stop="navToFareuploadAll(contLs)"

                              v-c-tooltip.hover="{ content: $t('contract.fareUploadTooltip') , active:false }"
                      >
                        <img src="@/assets/az/img/svg/icons/fareupload.svg" alt width="32px" class="c-pointer" />
<!--                                              <span>{{$t('addContract.addFareUpload')}}</span>-->
                      </div>
                    </CCol>
                    <CCol>
                      <div
                              @click.stop="navToFareRuleAll(contLs)"

                              v-c-tooltip.hover="{ content: $t('contract.fareRuleTooltip') , active:false }"
                      >
                        <img src="@/assets/az/img/svg/icons/farerule.svg" alt width="20px" class="c-pointer" />
<!--                                              <span>{{$t('addContract.addFareRule')}}</span>-->
                      </div>
                    </CCol>
                   
                    <CCol>
                      <div
                              @click.stop="navigateToAddContract(contLs)"
                              col="2.5"
                              v-if="allContractLs.permission.canEdit"
                              class="edit-icon icon-25px c-pointer"
                              color="info removewrap"
                              v-c-tooltip.hover="{ content: $t('contract.editTooltip') , active:false }"
                      >
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="512pt"
                                viewBox="0 0 512 512"
                                width="512pt"
                                style="fill:#3c4b64;"
                        >
                          <path
                                  d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                                  d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                                  d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>

                     <CCol>
                      <div
                              @click.stop="toDeleteContract(contLs.contractid)"
                              col="2.5"
                              v-if="allContractLs.permission.canDelete"
                              size="sm"
                              color="danger"
                              v-c-tooltip.hover="{ content: $t('contract.deleteTooltip') , active:false }"
                              class=" icon-25px c-pointer"
                      >
                        <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                      </div>
                    </CCol>


                  </div>
                </div>
              </div>
            </CCard>
          </div>
          <!-- <CCard @click="getFareRule(selectedContract)" v-if="selectedContract.contractcode!= 'All'" class="card assign pricing-card">
            <div class="card-head d-flex ai-center">
              <div class="align-left a-name d-flex align-items-end">
                <div class="mr-10px">
                  <h3 v-if="selectedContract.contractcode" class="text-transform-uppercase">{{selectedContract.contractcode}}</h3>
                  <span v-if="selectedContract.description">{{selectedContract.description}}</span>
                </div>
                <CBadge
                  class="c-white"
                  :color="selectedContract.isactive? 'success' : 'danger'"
                >{{selectedContract.isactive? $t("contract.active"): $t("contract.inactive")}}</CBadge>
              </div>
              <div class="align-right d-flex"> -->
                <!-- <div
                    col="1.5"
                    size="sm"
                    color="info removewrap"
                     v-c-tooltip.hover="{ content: $t('contract.viewTooltip') , active:false }"
                    class="action-c-btn icon-25px c-pointer"
                  >
                    <CIcon  name="cil-info" size="lg"></CIcon>
                  </div> -->
                <!-- <div
                  @click.stop="toDeleteContract(selectedContract.contractid)"
                  col="2.5"
                  v-if="allContractLs.permission.canDelete"
                  size="sm"
                  color="danger"
                  v-c-tooltip.hover="{ content: $t('contract.deleteTooltip') , active:false }"
                  class="action-c-btn"
                >
                  <CIcon style="color: #cd0606;" name="cil-trash" size="lg"></CIcon>
                </div> -->
                <!-- <div
                 @click.stop="navigateToAddContract(selectedContract)"
                  v-if="allContractLs.permission.canEdit"
                  col="2.5"
                  class="edit-icon"
                  color="info removewrap"
                  v-c-tooltip.hover="{ content: $t('contract.editTooltip') , active:false }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="512pt"
                    viewBox="0 0 512 512"
                    width="512pt"
                    style="fill:#3c4b64;"
                  >
                    <path
                      d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                    />
                    <path
                      d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                    />
                    <path
                      d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                    />
                  </svg>
                </div> -->
              <!-- </div>
            </div>
            <div class="card-head d-flex ai-center justify-content-between d-flex pt-15px">
              <div class="align-left a-name">
                <table class="contract">
                  <tbody>
                    <tr v-if="selectedContract.airline_code">
                      <td>{{$t("contract.airlineCode")}}</td>
                      <td>: {{selectedContract.airline_code}}</td>
                    </tr>
                    <tr v-if="selectedContract.traveldate_from && selectedContract.traveldate_to">
                      <td>{{$t("contract.travelDate")}}</td>
                      <td>: {{selectedContract.traveldate_from+' - '+selectedContract.traveldate_to}}</td>
                    </tr>
                    <tr
                      v-if="selectedContract.ticketingdate_from && selectedContract.ticketingdate_to"
                    >
                      <td>{{$t("contract.ticketingDate")}}</td>
                      <td>: {{selectedContract.ticketingdate_from+' - '+selectedContract.ticketingdate_to}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button-wrap-r mt-auto">
                <div class="row">
                  <CCol>
                   <div
                    col="1.5"
                    size="sm"
                    color="info removewrap"
                     v-c-tooltip.hover="{ content: $t('contract.viewTooltip') , active:false }"
                    class="action-c-btn icon-25px c-pointer"
                  >
                    <CIcon  name="cil-info" size="lg"></CIcon>
                  </div>
                  </CCol>
                  <CCol>
                    <div
                            @click.stop="navToScheduleAll(selectedContract)"
                            v-c-tooltip.hover="{ content: $t('addContract.addFlightSchedule') , active:false }"
                    >
                      <img src="@/assets/az/img/svg/icons/flightschedule.svg" alt width="25px" class="c-pointer"/>
                    
                    </div>
                  </CCol>
                  <CCol>
                    <div
                            @click.stop="navToFareuploadAll(selectedContract)"

                            v-c-tooltip.hover="{ content: $t('addContract.addFareUpload') , active:false }"
                    >
                      <img src="@/assets/az/img/svg/icons/fareupload.svg" alt width="32px" class="c-pointer" />
                     
                    </div>
                  </CCol>
                  <CCol>
                    <div
                            @click.stop="navToFareRuleAll(selectedContract)"

                            v-c-tooltip.hover="{ content: $t('addContract.addFareRule') , active:false }"
                    >
                      <img src="@/assets/az/img/svg/icons/farerule.svg" alt width="20px" class="c-pointer" />
                     
                    </div>
                  </CCol>
                  <CCol>
                    <div
                            @click.stop="toDeleteContract(selectedContract.contractid)"
                            col="2.5"
                            v-if="allContractLs.permission.canDelete"
                            size="sm"
                            color="danger"
                            v-c-tooltip.hover="{ content: $t('contract.deleteTooltip') , active:false }"
                            class=" icon-25px c-pointer"
                    >
                      <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                            @click.stop="navigateToAddContract(selectedContract)"
                            col="2.5"
                            v-if="allContractLs.permission.canEdit"
                            class="edit-icon icon-25px c-pointer"
                            color="info removewrap"
                            v-c-tooltip.hover="{ content: $t('contract.editTooltip') , active:false }"
                    >
                      <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="512pt"
                              viewBox="0 0 512 512"
                              width="512pt"
                              style="fill:#3c4b64;"
                      >
                        <path
                                d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                        />
                        <path
                                d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                        />
                        <path
                                d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                        />
                      </svg>
                    </div>
                  </CCol>



                </div>
              </div> -->
<!--              <div class="button-wrap-r">-->
<!--                <div class="d-flex flex-flow-wrap">-->
<!--                  <div-->
<!--                    @click.stop="navToScheduleAll(selectedContract)"-->
<!--                    class="button-wrap-radius"-->
<!--                    v-c-tooltip.hover="{ content: $t('addContract.addFlightSchedule') , active:false }"-->
<!--                  >-->
<!--                    <img src="@imgPath/img/svg/icons/plus-bold.svg" alt />-->
<!--                    <span>{{$t('addContract.addFlightSchedule')}}</span>-->
<!--                  </div>-->
<!--                  <div-->
<!--                    @click.stop="navToFareuploadAll(selectedContract)"-->
<!--                    class="button-wrap-radius"-->
<!--                    v-c-tooltip.hover="{ content: $t('addContract.addFareUpload') , active:false }"-->
<!--                  >-->
<!--                    <img src="@imgPath/img/svg/icons/plus-bold.svg" alt />-->
<!--                    <span>{{ $t('addContract.addFareUpload')}}</span>-->
<!--                  </div>-->
<!--                  <div-->
<!--                    @click.stop="navToFareRuleAll(selectedContract)"-->
<!--                    class="button-wrap-radius"-->
<!--                    v-c-tooltip.hover="{ content: $t('addContract.addFareRule') , active:false }"-->
<!--                  >-->
<!--                    <img src="@imgPath/img/svg/icons/plus-bold.svg" alt />-->
<!--                    <span>{{$t('addContract.addFareRule')}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
            <!-- </div>
          </CCard> -->

          <CRow>
            <CAlert v-if="alertValue" show color="danger">
              <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
              </div>
              <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{'ErrorCode: '}}</span>
                <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
              </div>
              <div v-if="alertValue&&alertValue.constructor==String">
                <p>{{alertValue}}</p>
              </div>
            </CAlert>
          </CRow>
          <CRow>
            <CCol id="user-manage-table" class="usersTable border-grey manage-user-table"></CCol>
          </CRow>
        </div>
        <!-- table filter hidded
        tableFilter-->
        <!-- <button class="mf-success-round-btn">Apply</button> -->
      </CCardBody>
      <cAlertModal
        v-if="isShowAlertModal"
        :key="'CA'+alertCount"
        :buttonList="modalButton"
        :status="modalStatus"
        :isShowIcon="true"
        :show="isShowAlertModal"
        :desc="confirmTxt"
      ></cAlertModal>
    </CCard>
    <CModal :show.sync="toShowModal" size="xl" class="sub-dash-wrap" :closeOnBackdrop="true">
      <template #header-wrapper>
        <div></div>
      </template>

        <CCard v-if="fareRule" class="mb-0">
          <CCardHeader>
            <div class="title d-flex align-item-center justify-content-between mb-10px">
              <div class="left">
               <div>
                 <strong class="mr-15px">{{fareRule.contract_code}}</strong>

                  <CBadge col="6"
                         class="c-white"
                         :color="fareRule.selContract.isactive? 'success' : 'danger'"
                 >{{fareRule.selContract.isactive? $t("contract.active"): $t("contract.inactive")}}
                  </CBadge>
                 </div>
                <div>
                  {{$t('contract.modalDesc',{airlines: fareRule.airline_code})}}
                </div>

              </div>

              <div @click="toShowModal=false" class="right d-flex align-item-center mr-15px">


                <img class="close ml-10px" src="@imgPath/img/svg/icons/cross.svg" alt="">
              </div>
            </div>

                        <!-- </div> -->

        </CCardHeader>
          <CCardBody v-for="(fare,findex) in fareRule.FlightFareList" :key="'fare'+findex" >
             <div class="title d-flex align-item-center justify-content-between mb-10px">
              <div class="left">
               <div>
                 <strong class="mr-15px">{{fare.farerule_code}}</strong>
                 </div>
                <div>
                  {{fare.farerule_desc}}
                </div>

              </div>
            </div>
            <div class="d-flex align-item-center">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.advPurReq')}}</strong>
              </div>
              <div class="w-100">
                {{$t('contract.advPurReqDesc',{days: fare.advance_purchase_on_or_before_days})}}
              </div>
            </div>
            <br />
            <div v-if="fare.summary_json.blackout && fare.summary_json.blackout.length!=0" class="d-flex">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.balckoutDates')}}</strong>
              </div>
              <div class="w-100">
               <!-- <span v-for="(dates,index) in fareRule.FlightFareList" :key="'blackOut'+index" > -->
                  <span >
                    <span
                            v-for="(blackOut,bindex) in fare.summary_json.blackout"
                            :key="'blackOutDates'+bindex"
                    >
                      {{blackOut.datefrom}} {{' '+$t('contract.to')+' '}} {{blackOut.dateto}} 
                      <!-- <span v-if="index != dates.summary_json.blackout.length && dates.summary_json.blackout.length > 1">,</span> -->
                      <span v-if="bindex != fare.summary_json.blackout.length - 1">,</span>
                    </span>
                  </span>
                <!-- </span> -->
              </div>
            </div>
            <br v-if="fare.summary_json.blackout && fare.summary_json.blackout.length!=0" />
            <div  class="d-flex">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.dayTimeRes')}}</strong>

              </div>
              <div v-if="fare.summary_json.dayRestriction && fare.summary_json.dayRestriction.length!=0" class="w-100">
                {{$t('contract.dayDesc')}}
                <!-- <span v-for="(dates,dindex) in fareRule.FlightFareList" 
                        :key="'day'+dindex"
                        col="6" >-->
                  <span   class="d-flex flex--wrap" >
                    <span
                            v-for="(day,drindex) in fare.summary_json.dayRestriction"
                            :key="'dayRes'+drindex"
                    >
                      <strong>{{day.day}}</strong>
                      <!-- <span v-if="dindex != dates.summary_json.dayRestriction.length && dates.summary_json.dayRestriction.length > 1">,</span>-->
                      <span v-if="drindex != fare.summary_json.dayRestriction.length - 1">,</span> 
                    </span>
                  </span>
                <!-- </span> -->
              </div>
            </div>
            <br v-if="fare.summary_json.dayRestriction && fare.summary_json.dayRestriction.length!=0" />
            <div v-if="fare.summary_json.timeRestriction && fare.summary_json.timeRestriction.length!=0" class="d-flex">
              <div class="max-w-200px w-100">
              </div>
              <div class="w-100">
                <span>  {{$t('contract.timeDesc')}}</span>
                    <!-- <span v-for="(dates,tindex) in fareRule.FlightFareList" :key="'time'+tindex" col="6"> -->
                  <span >
                    <span v-for="(day,trindex) in fare.summary_json.timeRestriction" :key="'timeRes'+trindex">
                      <strong>{{day.timefrom}}{{' '+$t('contract.to')+' '}}{{day.timeto}} </strong>

                      <!-- <span v-if="tindex!=dates.summary_json.timeRestriction.length-1 && dates.summary_json.timeRestriction.length > 1">,</span>-->

                      <span v-if=" trindex != fare.summary_json.timeRestriction.length - 1">,</span> 
                    </span>
                  </span>
                <!-- </span> -->
              </div>
            </div>
            <br v-if="fare.summary_json.timeRestriction && fare.summary_json.timeRestriction.length!=0" />
            <div v-if="fare.summary_json.flightApplicability && fare.summary_json.flightApplicability.length!=0" class="d-flex">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.flightApplicability')}}</strong>
              </div>
              <div class="w-100">
                {{$t('contract.flightApplicabilityDesc')}}
                <!-- <span v-for="(dates,findex) in fareRule.FlightFareList" :key="'fli'+findex" col="6"> -->
                  <span  >
                    <span v-for="(flight,faindex) in fare.summary_json.flightApplicability" :key="'fliapp'+faindex">
                      <strong>{{flight.airling_code}}-{{flight.flight_number}}</strong>
                      <!-- <span v-if="findex != dates.summary_json.flightApplicability.length && dates.summary_json.flightApplicability.length > 1">,</span> -->
                      <span v-if="faindex != fare.summary_json.flightApplicability.length - 1">,</span> 
                    </span>
                  </span>
                <!-- </span> -->
              </div>
            </div>
            <br v-if="fare.summary_json.flightApplicability && fare.summary_json.flightApplicability.length!=0" />
            <div v-if="fare.summary_json.season && fare.summary_json.season.length!=0" class="d-flex">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.season')}}</strong>
              </div>
              <div class="w-100">
                  <!-- <span v-for="(dates,sindex) in fareRule.FlightFareList" :key="'sea'+sindex" col="6"> -->
                  <span >
                    <span v-for="(season,seindex) in fare.summary_json.season" :key="'season'+seindex">
                      {{season.datefrom}}{{' '+$t('contract.to')+' '}}{{season.dateto}}
                      <!-- <span v-if="sindex != dates.summary_json.season.length && dates.summary_json.season.length > 1">,</span>-->
                      <span v-if="seindex != fare.summary_json.season.length - 1">,</span> 
                    </span>
                  </span>
                <!-- </span> -->
              </div>
            </div>

            <br v-if="fare.summary_json.season && fare.summary_json.season.length!=0" />
            <div v-if="fare.summary_json.ticketingDeadline && fare.summary_json.ticketingDeadline.length!=0" class="d-flex">
              <div class="max-w-200px w-100">
                <strong>{{$t('contract.tcktDeadline')}}</strong>
              </div>
              <div class="w-100">
                <!-- <div v-for="(dates,tkindex) in fareRule.FlightFareList" :key="'tkt'+tkindex" col="6"> -->
                  <span >
                    <span v-for="(tckt,tktindex) in fare.summary_json.ticketingDeadline" :key="'tktdead'+tktindex"
                    >{{$t('contract.tcktdeadlineDesc',{count:tckt.ttl, units: tckt.ttl_units, from:tckt.range_from, to:tckt.range_to})}}</span>
                  </span>
                <!-- </div> -->
              </div>
            </div>
            <br />
            <hr v-if="fareRule.FlightFareList.length>1" />
          </CCardBody>
          <CCardBody v-if="fareRule.FlightFareList.length==0">
             <div>
               <strong>{{$t("contract.noFares")}}</strong>
             </div>
          </CCardBody>
          <CCardFooter>

            <CRow>
              <CCol md="6">
                <button @click.stop="navigateToFareView(fareRule.selContract)" type="button" class="btn action-c-btn btn-danger  mr-15px mr-auto" >{{'View Fare'}}</button>
              </CCol>
              <CCol md="6" class="d-flex">
                <button @click.stop="toDeleteContract(fareRule.selContract.contractid)" v-if="fareRule.permission.canDelete"    type="button" class="btn action-c-btn btn-danger ml-auto mr-15px">{{$t('contract.modalDelete')}}</button>
                <button @click="navigateToAddContract(fareRule.selContract)" v-if="fareRule.permission.canEdit"  class="btn action-c-btn btn-success removewrap "> {{$t('contract.modalEdit')}} </button>
              </CCol>


<!--                              <button @click="navigateToAddContract(fareRule.selContract)" v-if="fareRule.permission.canEdit"  class=" blue-primary-btn mt-10px continue-btn">{{$t('contract.modalEdit')}}-->
<!--                              </button>-->
<!--                              <button class="blue-primary-btn mt-10px continue-btn" @click.stop="toDeleteContract(fareRule.selContract.contractid)" v-if="fareRule.permission.canDelete" >{{$t('contract.modalDelete')}}-->
<!--                              </button>-->

                          </CRow>
          </CCardFooter>
        </CCard>

    </CModal>
  </div>
</template>

<script>
import router, { navigate } from "../../../router/index";

import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  ORDER,
  ALERT_MODAL_STATUS
} from "../../../util/constants";
import Logger from "../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../config/API_DATA";
import multiselect from "vue-multiselect";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData
} from "../../../util/util";
import BaseConfiguration from "../../../config/base.js";
import apiGetAllContract from "../../../services/apiGetAllContract";
import apiDeleteContract from "../../../services/apiDeleteContract";
import cAlertModal from "../../../components/form/cAlertModal";
import apiCRSGetFareRule from "../../../services/apiCRSGetFareRule";
import cPaginationLenOption from "../../../components/dataTable/cPaginationLenOption";
import apiGetAllCrsEnum from "../../../services/apiGetAllCrsEnum";

export default {
  name: COMPONENT_NAME.CONTRACT_ALL,
  components: {
    multiselect,
    cAlertModal,
    cPaginationLenOption
  },

  data: () => {
    return {
      allContractLs: null,
      alertValue: null,
      alertCount:0,
     selectedContract: null,
     selectedContractLs: [],
      selContDet: null,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      fareRule: null,
      toShowModal: false,
       pageWatchList: {
                    filteredlistCount: null,
                    itemsPerPage: 25,
                    currentPageNum: 1,
                    lsItemsPerPage: [5, 10, 15, 25]
                },
    };
  },

   watch: {
            selectedContractLs: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {


                    this.pageWatchList.filteredlistCount = this.selectedContractLs.length-1;


                },
            }

        },

  methods: {
    ...mapActions("sContract", ["SET_SELECTED_CONTRACT"]),
        ...mapActions("sContract",{ SET_ALL_CONTRACT_RES:"SET_ALL_CONTRACT_RES",SET_ALL_CRS_ENUMS:"SET_ALL_CRS_ENUMS"}),

     getTotalPages() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalPages");
                    if (this.pageWatchList.filteredlistCount != null) {
                        let totalPages = this.pageWatchList.filteredlistCount / this.pageWatchList.itemsPerPage;
                        retValue = Math.ceil(totalPages);


                        if (retValue <= 0) {
                            retValue = 1;
                        }
                    } else {
                        retValue = 1;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getTotalPages",
                        err.toString(),
                        "getTotalPages",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

             getStartValueCount() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartValueCount");
                    if (this.pageWatchList.filteredlistCount == 0) {
                        retValue = 0;
                    } else {
                        if (
                            this.pageWatchList.itemsPerPage <
                            this.pageWatchList.filteredlistCount
                        ) {
                            retValue =
                                (this.pageWatchList.currentPageNum - 1) *
                                this.pageWatchList.itemsPerPage;
                            retValue = retValue + 1;
                        } else {
                            retValue = 1;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getStartValueCount",
                        err.toString(),
                        "getStartValueCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getListCountForView(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getListCountForView");
                    let count = 0;


                    count = pIndex + 1;


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getListCountForView",
                        err.toString(),
                        "getListCountForView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getFilteredListPerPage() {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getFilteredListPerPage");
                    if (
                        this.pageWatchList.itemsPerPage <
                        this.pageWatchList.filteredlistCount
                    ) {
                        if (
                            this.pageWatchList.currentPageNum *
                            this.pageWatchList.itemsPerPage >
                            this.pageWatchList.filteredlistCount
                        ) {
                            retValue = this.pageWatchList.filteredlistCount;
                        } else {
                            retValue =
                                this.pageWatchList.currentPageNum *
                                this.pageWatchList.itemsPerPage;
                        }
                    } else {
                        retValue = this.pageWatchList.filteredlistCount;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CONTRACT_ALL,
                        "error in getFilteredListPerPage",
                        err.toString(),
                        "getFilteredListPerPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


    navToScheduleAll(pSelectedContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToScheduleAll");
        this.SET_SELECTED_CONTRACT(pSelectedContract);
        navigate(PATHNAME.SCHEDULE_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in navToScheduleAll",
          err.toString(),
          "navToScheduleAll",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToFareuploadAll(pSelectedContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToFareuploadAll");
                this.SET_SELECTED_CONTRACT(pSelectedContract);

        navigate(PATHNAME.FARE_UPLOAD_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in navToFareuploadAll",
          err.toString(),
          "navToFareuploadAll",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToFareRuleAll(pSelectedContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToFareRuleAll");
                this.SET_SELECTED_CONTRACT(pSelectedContract);

        navigate(PATHNAME.FARE_RULE_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in navToFareRuleAll",
          err.toString(),
          "navToFareRuleAll",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onChange(pSelectedContract) {
     // let retValue;
      let allContLs;
      try {
        if (BaseConfiguration.isDebug) console.log("onChange");
        this.selectedContractLs = [];
        if(pSelectedContract.contractcode && pSelectedContract.contractcode == DEFAULT_DROPDOWN_STATUS.ALL){
          this.selectedContractLs = this.allContractLs.contractList
        }
        else{
        allContLs = this.allContractLs;
        this.selectedContractLs.push(this.allContractLs.contractList[0])
        for (let i = 0; i < allContLs.contractList.length; i++) {
          if (
            pSelectedContract.contractcode ==
              allContLs.contractList[i].contractcode &&
            pSelectedContract.contractcode != null
          ) {
            //this.selContDet = allContLs.contractList[i];
            this.selectedContractLs.push(allContLs.contractList[i])
            break;
          }
        }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in onChange",
          err.toString(),
          "onChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
     // return retValue;
    },

    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    toDeleteContract(pContractid) {
      try {
        if (BaseConfiguration.isDebug) console.log("toDeleteContract");

        this.showAlertModal(
          ALERT_MODAL_STATUS.INFO,
          this.$t("contract.deleteConfirm"),
          pContractid
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.EXTENSION_SETUP,
          "error in toDeleteContract",
          err.toString(),
          "toDeleteContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    showAlertModal(status, val, pParam) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("addContract.cancel"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("addContract.yes"),
            func: this.deleteContract,
            param: pParam ? pParam : null
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("addContract.ok"),
            func: this.toGetContract
          }
        ];
      }
      this.confirmTxt = val;
    },

    async GetAllContract() {
      if (BaseConfiguration.isDebug) console.log("GetAllContract");
      let returnValue;
      try {
        let GetAllContractReq = apiGetAllContract.buildRequest(); //constant

        if (GetAllContractReq != null) {
          let GetAllContractRes = await apiGetAllContract.getResponse(
            GetAllContractReq
          );
          if (VALIDATE_SUCCESS_RES(GetAllContractRes)) {
                        this.alertValue=null;

            this.SET_ALL_CONTRACT_RES(cloneData(GetAllContractRes.data.data.contractList));
            returnValue = GetAllContractRes.data.data;
          } else {
            let error = getErrorMessage(GetAllContractRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getGetAllContract",
          err.toString(),
          "getGetAllContract()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async deleteContract(pContractid) {
      if (BaseConfiguration.isDebug) console.log("deleteContract");
      let returnValue;
      try {
        if(this.toShowModal==true){
          this.toShowModal=false;
        }
        this.isShowAlertModal = false;
        let deleteContractReq;
        if (pContractid) {
          deleteContractReq = apiDeleteContract.buildRequest(pContractid); //constant
        }
        if (deleteContractReq != null) {
          let deleteContractRes = await apiDeleteContract.getResponse(
            deleteContractReq
          );
          if (VALIDATE_SUCCESS_RES(deleteContractRes)) {
                         this.alertValue=null;

            returnValue = deleteContractRes.data.data;
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("contract.deleteSuccess")
            );
          } else {
            let error = getErrorMessage(deleteContractRes);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error,true,true);
            }
            this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  deleteContract",
          err.toString(),
          "deleteContract()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getFareRule(pContractid) {
      if (BaseConfiguration.isDebug) console.log("getFareRule");
      let returnValue;
      try {
        let getFareRuleReq;
        if (pContractid) {
          getFareRuleReq = apiCRSGetFareRule.buildRequest(pContractid.contractid); //constant
        }
        if (getFareRuleReq != null) {
          let getFareRuleRes = await apiCRSGetFareRule.getResponse(
            getFareRuleReq
          );
          if (VALIDATE_SUCCESS_RES(getFareRuleRes)) {
             this.alertValue=null;
            returnValue = getFareRuleRes.data.data;
           // if(returnValue.FlightFareList.length!=0) {
            this.fareRule = returnValue;
            this.fareRule["selContract"] = pContractid;
            this.fareRule["airline_code"] = pContractid.airline_code;
            this.fareRule["contract_code"] = pContractid.contractcode;
            this.toShowModal = true;
           // }
            
          } else {
            let error = getErrorMessage(getFareRuleRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getFareRule",
          err.toString(),
          "getFareRule()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    navigateToFareView(pSelectedContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToFareView");
        if (pSelectedContract) {
          this.SET_SELECTED_CONTRACT(pSelectedContract);
        } else {
          this.SET_SELECTED_CONTRACT(null);
        }
        navigate(PATHNAME.FARE_VIEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_ALL,
          "error in navigateToFareView",
          err.toString(),
          "navigateToFareView",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navigateToAddContract(pSelectedContract) {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToAddContract");
        if (pSelectedContract) {
          this.SET_SELECTED_CONTRACT(pSelectedContract);
        } else {
          this.SET_SELECTED_CONTRACT(null);
        }
        navigate(PATHNAME.CONTRACT_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_ALL,
          "error in navigateToAddContract",
          err.toString(),
          "navigateToAddContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    getContractPropToSort(pContract) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getContractPropToSort");
          
              retValue =pContract.contractcode.toString().toLowerCase()
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_ALL,
                  "error in getContractPropToSort",
                  err.toString(),
                  "getContractPropToSort",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    async toGetContract() {
      try {
        if (BaseConfiguration.isDebug) console.log("toGetContract");
        let contractLs = await this.GetAllContract();
       // contractLs  = 
        this.isShowAlertModal = false;
        let allCont;
        allCont = {
          contractcode: DEFAULT_DROPDOWN_STATUS.ALL,
          contractid: null
        };
        if(contractLs) {
          contractLs.contractList =OrderByList(  contractLs.contractList,this.getContractPropToSort,ORDER.ASC)
        contractLs.contractList.unshift(allCont);
        this.allContractLs = contractLs;
        this.selectedContract = this.allContractLs.contractList[0];
       this.selectedContractLs = this.allContractLs.contractList;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT_ALL,
          "error in toGetContract",
          err.toString(),
          "toGetContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async setAllCrsEnums() {
      try {
        if (BaseConfiguration.isDebug) console.log("setAllCrsEnums");
       
        let enumReq = apiGetAllCrsEnum.buildRequest();

        if (enumReq) {
          let enumRes = await apiGetAllCrsEnum.getResponse(
            enumReq
          );

          if (VALIDATE_SUCCESS_RES(enumRes)) {
            this.alertValue = null;
             this.SET_ALL_CRS_ENUMS(enumRes.data.data);
          } else {
            let error = getErrorMessage(enumRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SCHEDULE_NEW,
          "error in setAllCrsEnums",
          err.toString(),
          "setAllCrsEnums",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {

      if(!this.GET_ALL_CRS_ENUMS)
      {      await this.setAllCrsEnums();}
      
      
      this.toGetContract();
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.CONTRACT_ALL,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
     ...mapGetters("sContract", {
     
      GET_ALL_CRS_ENUMS:"GET_ALL_CRS_ENUMS"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.CONTRACT_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>

<style scoped>
.stickyTitleBar {
    padding: 10px 15px;
    position: sticky;
    top: 14px;
  }
  
  /* .card.assign.pricing-card {
  &.sticky-title-bar {
    padding: 20px 25px;
    position: sticky;
    top: 14px;
    z-index: 9;

    label.title {
      width: 50%;
      display: flex;
      align-items: center;
      margin-bottom: 0px;
    }

    .multiselect-assignprice {
      width: 100%;
      max-width: 300px;
      margin-left: auto;

      ul.multiselect__content {
        overflow: hidden;
        max-width: 100%;
      }
    }
  } */
</style>
